<template>
  <div>
    <div class="section-summary-row">
      <span>{{ resources.orderConfirmationHeader }}</span>
      <span class="body-text">{{ email }}</span>
      <span class="body-text" v-if="phone">{{ phone }}</span>
      <span class="body-text dimmed" v-if="!phone">{{ resources.noPhoneLabel }}</span>
    </div>

    <div class="section-summary-row">
      <span v-if="sameAsDelivery">{{resources.billingSameAsDeliveryLabel}} </span>
      <span v-if="!sameAsDelivery">{{ resources.billingAddressHeader }}</span>
      <span class="body-text" v-if="!sameAsDelivery" v-html="address"/>
      <span class="body-text" v-if="shouldShowVat">{{ vat }}</span>
      <span class="body-text dimmed" v-if="shouldShowVat && !vat">{{ resources.noVATLabel }}</span>
    </div>
  </div>
</template>
<script src="./details-summary.js"/>
